// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__YXjvh","modalFooterButton":"ModalNotes_modalFooterButton__2vxeT"};